import request from '@/utils/request'

export function getKhoroojInfo() {
  return request({
    url: 'khoroojazkeshvar/data',
    method: 'post'
  })
}

export function requestKhorooj(country, from, to, comment) {
  return request({
    url: 'khoroojazkeshvar/request',
    method: 'post',
    data: { azTarikh: from, taTarikh: to, tarikhPassport: "", countryName: country, comment: comment }
  })
}

export function getKhoroojHistory() {
  return request({
    url: 'khoroojazkeshvar/history',
    method: 'post'
  })
}

export function removeKhoroojRequest(requestID) {
  return request({
    url: 'khoroojazkeshvar/remove',
    method: 'post',
    data: { requestID: requestID }
  })
}

export function getLastKhorooj() {
  return request({
    url: 'khoroojazkeshvar/last',
    method: 'post'
  })
}

export function saveLastKhorooj(requestID, from, to, noTrip) {
  return request({
    url: 'khoroojazkeshvar/savelast',
    method: 'post',
    data: { requestID: requestID, tarikhRaft: from, tarikhBarghasht: to, noSafar: noTrip }
  })
}








